import React from 'react';

import logo from '../assets/logo.png'; // Pfad ggf. anpassen
import { Link } from 'react-router-dom';
import './home.css'; // gleiche Styles wie bei Home verwenden
import Bodentemperatur from '../components/Bodentemperatur';


function BodentemperaturKollerhube() {
  return (
    <div className="home-container">
      <div className="home-diagramm">
      <div className='wetter-container'><h1 >BODENTEMPERATUR</h1></div>
        <Bodentemperatur ort="kollerhube" />
      </div>
    </div>
  );
}

export default BodentemperaturKollerhube;
